var blocks = document.querySelectorAll(".acf-hero-slider");
blocks.forEach(function (block) {
	const carousel = block.querySelector(".items");
	const slides = carousel.querySelectorAll(".items > *");
	const pager = block.querySelector(".pager");

	const observerSettings = {
		root: carousel,
		rootMargin: "-20px",
	};

	// We need intersection observer for this to work
	if ("IntersectionObserver" in window) {
	} else {
		return false;
	}

	// We don't need to do anything if there's only one slide
	if (slides.length <= 1) {
		return false;
	}

	// Set basics for the carousel
	carousel.classList.add("js-active");
	carousel.setAttribute("data-current-slide", 0);
	slides.forEach(function (slide, index) {
		// Set data attribute for slide number
		slide.setAttribute("data-slide", index);
	});

	var goToSlide = function goToSlide(index) {
		var targetSlide = carousel.querySelector("[data-slide='" + index + "']");

		if (targetSlide) {
			carousel.scrollTo({
				left: targetSlide.clientWidth * index,
				behavior: "smooth",
			});
		} else {
			console.error("Could not show slide: " + index);
		}
	};

	var setActiveSlide = function setActiveSlide(slides, observer) {
		Array.prototype.forEach.call(slides, function (entry) {
			var slide = entry.target;

			// All slides:
			// - Remove visible class
			// - Set all links to be non-interactive
			var slide_links = slide.querySelectorAll("a");
			slide_links.forEach(function (link) {
				link.setAttribute("tabindex", "-1");
			});

			// Bail if the slide is not visible
			if (!entry.intersectionRatio > 0) {
				return;
			}

			// We now know this is the active slide
			var index = slide.getAttribute("data-slide");
			// console.log("Set active slide: " + index);
			// console.log(slide);

			// Set all links to be interactive
			slide_links.forEach(function (link) {
				link.removeAttribute("tabindex", "-1");
			});

			// Set active pager dot
			var pager_dots = pager.querySelectorAll(".pager__dot");
			pager_dots.forEach(function (dot) {
				if (dot.dataset.slide === index) {
					dot.classList.add("active");
				} else {
					dot.classList.remove("active");
				}
			});

			// Update carousel class for active slide
			carousel.setAttribute("data-current-slide", index);
		});
	};

	// Add pager
	// https://codepen.io/electerious/pen/JXNEPr/ is the inspiration behind the pager functionality
	slides.forEach(function (slide, index) {
		// console.log(index);
		var newDot = document.createElement("button");
		newDot.classList.add("pager__dot");
		newDot.setAttribute("data-slide", index);

		var newDotLabel = document.createElement("span");
		newDotLabel.classList.add("visually-hidden");
		newDotLabel.textContent = "Slide " + (index + 1);

		newDot.append(newDotLabel);

		// add click event to go to slide
		newDot.addEventListener("click", (event) => {
			var currentSlide = parseInt(carousel.getAttribute("data-current-slide"));
			// console.log("clicked pager item: " + index);
			// console.log("active slide: " + currentSlide);

			if (index !== currentSlide) {
				newDot.classList.add("active");
				goToSlide(index);
			}
		});

		pager.appendChild(newDot);
	});

	// Add controls
	var controls = block.querySelector(".controls");
	controls.setAttribute("aria-label", "carousel controls");
	controls.innerHTML =
		'\n    <li><button type="button" class="previous hero-slide-btn" data-direction="previous" aria-label="Previous Slide">\n <svg aria-hidden="true" focusable="false"><use xlink:href="#slider-arrow-left"></use></svg>\n    </button></li>\n    <li><button type="button" class="next hero-slide-btn" data-direction="next" aria-label="Next Slide">\n      <svg aria-hidden="true" focusable="false"><use xlink:href="#slider-arrow-right"/></svg>\n    </button></li>\n    ';

	var nextButton = controls.querySelector("[data-direction='next']");
	nextButton.addEventListener("click", function (event) {
		var currentSlide = parseInt(carousel.getAttribute("data-current-slide"));

		if (currentSlide < slides.length - 1) {
			goToSlide(currentSlide + 1);
		} else {
			goToSlide(0);
		}
	});

	var prevButton = controls.querySelector("[data-direction='previous']");
	prevButton.addEventListener("click", function (event) {
		var currentSlide = parseInt(carousel.getAttribute("data-current-slide"));

		if (currentSlide > 0) {
			goToSlide(currentSlide - 1);
		} else {
			goToSlide(1);
		}
	});

	// Add observer of slide changing
	var observer = new IntersectionObserver(setActiveSlide, observerSettings);
	Array.prototype.forEach.call(slides, function (t) {
		return observer.observe(t);
	});
});
